// Small stroke icons (24-unit grid, currentColor), drawn in the Lucide style.
import { h } from 'preact';

const P = {
  read: 'M4 4h11l5 5v11H4z M15 4v5h5 M8 13h8 M8 17h6',
  write: 'M4 4h11l5 5v11H4z M15 4v5h5 M12 11v6 M9 14h6',
  edit: 'M4 20h4L19 9l-4-4L4 16z M13 7l4 4',
  shell: 'M4 5h16v14H4z M7 9l3 3-3 3 M12 15h5',
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14z M20 20l-4-4',
  web: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z M3 12h18 M12 3c3 3 3 15 0 18 M12 3c-3 3-3 15 0 18',
  todo: 'M9 6h11 M9 12h11 M9 18h11 M4 6l1 1 2-2 M4 12l1 1 2-2 M4 18l1 1 2-2',
  question: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6V14 M12 17h.01',
  plan: 'M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3z M9 3v15 M15 6v15',
  thought: 'M9 18h6 M10 21h4 M12 3a6 6 0 0 0-4 10.5c.7.7 1 1.5 1 2.5h6c0-1 .3-1.8 1-2.5A6 6 0 0 0 12 3z',
  tool: 'M14 6a4 4 0 0 0 5 5l-9 9-3-3 9-9a4 4 0 0 0-2-2z',
  check: 'M5 12l5 5L19 7',
  x: 'M6 6l12 12 M18 6L6 18',
  clip: 'M20 11l-8.5 8.5a5 5 0 0 1-7-7L13 4a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L14 7',
  send: 'M12 19V5 M5 12l7-7 7 7',
  stop: 'M7 7h10v10H7z',
  copy: 'M9 9h11v11H9z M5 15H4V4h11v1',
  retry: 'M4 12a8 8 0 1 0 2.3-5.7 M4 4v5h5',
  files: 'M3 6h6l2 2h10v11H3z',
  menu: 'M4 7h16 M4 12h16 M4 17h16',
  plus: 'M12 5v14 M5 12h14',
  close: 'M6 6l12 12 M18 6L6 18',
  download: 'M12 4v11 M7 10l5 5 5-5 M5 20h14',
  external: 'M14 4h6v6 M20 4l-9 9 M18 14v6H4V6h6',
  down: 'M12 5v14 M5 12l7 7 7-7',
  image: 'M4 5h16v14H4z M4 16l5-5 4 4 3-3 4 4 M15 9h.01',
  pdf: 'M5 3h10l4 4v14H5z M15 3v4h4 M8 13h2a1.5 1.5 0 0 1 0 3H8v-5 M14 16v-5h2',
  sheet: 'M4 4h16v16H4z M4 10h16 M4 15h16 M10 4v16',
  doc: 'M5 3h10l4 4v14H5z M15 3v4h4 M8 12h8 M8 16h8',
  code: 'M9 8l-4 4 4 4 M15 8l4 4-4 4',
  folder: 'M3 6h6l2 2h10v11H3z',
  pencil: 'M4 20h4L19 9l-4-4L4 16z',
  archive: 'M3 4h18v4H3z M5 8v12h14V8 M10 12h4',
  spark: 'M12 3v4 M12 17v4 M3 12h4 M17 12h4 M6 6l2.5 2.5 M15.5 15.5L18 18 M6 18l2.5-2.5 M15.5 8.5L18 6',
};

export function Icon({ name, size = 16, className }) {
  const d = P[name] || P.tool;
  return h('svg', { viewBox: '0 0 24 24', width: size, height: size, className: 'ico ' + (className || ''),
    fill: 'none', stroke: 'currentColor', 'stroke-width': 1.8, 'stroke-linecap': 'round',
    'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' },
    d.split(' M').map((seg, i) => h('path', { key: i, d: (i ? 'M' : '') + seg })));
}

export const KIND_ICON = {
  file_read: 'read', file_write: 'write', file_edit: 'edit', shell: 'shell', file_search: 'search',
  web_search: 'web', web_fetch: 'web', todo: 'todo', user_question: 'question', plan: 'plan',
};

export function fileIcon(path, type) {
  const p = (path || '').toLowerCase();
  const t = type || '';
  if (t.startsWith('image/') || /\.(png|jpe?g|gif|webp|svg|bmp)$/.test(p)) return 'image';
  if (t === 'application/pdf' || p.endsWith('.pdf')) return 'pdf';
  if (/\.(csv|xlsx?|ods|tsv)$/.test(p)) return 'sheet';
  if (/\.(docx?|odt|rtf|md|txt|pptx?)$/.test(p)) return 'doc';
  if (/\.(py|js|ts|html?|css|json|ya?ml|toml|sh|sql|rs|go|java|c|h|cpp)$/.test(p)) return 'code';
  return 'read';
}
